import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from "react-redux";
import { clearCreateStripeAccount } from 'redux/commerce/actions';

import CommonModal from 'components/elements/modals/CommonModal';
import AddPaymentProviderSelectStep
  from 'components/dashboard/settings-content/commerce/modals/AddPaymentProviderSelectStep';
import ConnectStripeStep1
  from 'components/dashboard/settings-content/commerce/modals/stripe/ConnectStripeStep1';
import ConnectStripeStep2
  from 'components/dashboard/settings-content/commerce/modals/stripe/ConnectStripeStep2';
import ConnectStripeStep3
  from 'components/dashboard/settings-content/commerce/modals/stripe/ConnectStripeStep3';

import './AddPaymentProviderModal.css';

function AddPaymentProviderModal(props) {
  const {
    open,
    onClose,
    clearCreateStripeAccount,
  } = props;

  const [activeStep, setActiveStep] = useState('select-provider');
  const [stripeCountry, setStripeCountry] = useState(null);
  const [stripeCurrency, setStripeCurrency] = useState(null);

  const onModalClose = () => {
    setActiveStep('select-provider');
    onClose();
    clearCreateStripeAccount();
  };

  return (
    <CommonModal
      className="add-payment-provider-modal__component"
      open={open}
      onClose={onModalClose}
    >
      {activeStep === 'select-provider' &&
        <AddPaymentProviderSelectStep
          onClose={onModalClose}
          setActiveStep={setActiveStep}
        />
      }

      {/* Stripe Steps */}
      {activeStep === 'stripe-step-1' &&
        <ConnectStripeStep1 setActiveStep={setActiveStep}/>
      }
      {activeStep === 'stripe-step-2' &&
        <ConnectStripeStep2
          setActiveStep={setActiveStep}
          setStripeCountry={setStripeCountry}
          setStripeCurrency={setStripeCurrency}
        />
      }
      {activeStep === 'stripe-step-3' &&
        <ConnectStripeStep3
          setActiveStep={setActiveStep}
          stripeCountry={stripeCountry}
          stripeCurrency={stripeCurrency}
          onClose={onModalClose}
        />
      }
    </CommonModal>
  );
}

AddPaymentProviderModal.propTypes = {
  clearCreateStripeAccount: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool,
};

AddPaymentProviderModal.defaultProps = {
  open: null,
};

const mapStateToProps = state => (
  {}
);

export default connect(
  mapStateToProps,
  {
    clearCreateStripeAccount,
  },
)(AddPaymentProviderModal);
